module.exports = __webpack_public_path__ + "img/MaskGroup 2883.47f5ee7f.svg";